export default function isLocalhost(): boolean {
	const { hostname } = window.location
	return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.')
}
